import Pricing from "./Pricing";
import axiosClient from "../../../service/axios";
import { SyncOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";

const GetPricingData = () => {
    const [data, setData] = useState([]);
    // console.log(data, "data");
    const [loading, setLoading] = useState(false);

    const pricingHandler = async () => {
        setLoading(true);
        try {
          const response = await axiosClient.get(
            "https://plus.lifebank.ng/lite/v2/api/admin/failed/orders/pricing",
          );
    
          const responseData = response?.data?.data;
          // console.log(responseData, "response");
          setData(responseData);
          setLoading(false);
        } catch (error) {
          console.log("error is decline");
        }
      };
    
      useEffect(() => {
        pricingHandler();
      }, []);

  return (
    <div>
    {data.length > 0 ? (
      data.map((item, index) => (
        <Pricing
          key={index}
          agent={item.agent}
          channel={item.channel}
          vendor_id={item.vendor_id}
          discount={item.discount}
          dispatch={item.dispatch}
          order_by={item.order_by}
          order_id={item.order_id}
          order_state={item.order_state}
          payment={item.payment}
          requester={item.requester}
          decline_by={item.decline_by}
          status={item.status}
          total={item.total}
          bgColor={item.bgColor}
          color={item.color}
          icon={item.icon}
          qty={item.qty}
          title={item.title}
          reason={item.reason}
          product={item.product}
          fone={item.fone}
          personnel_name={item.personnel_name}
          order_amt={item.order_amt}
          name={item.name}
          address={item.address}
          city={item.city}
          state={item.state}
          level={item.class}
          order_source={item.order_source}
          tym={item.tym}
          dispatch_name={item.dispatch_name}
          vendor_name={item.vendor_name}
          payment_type={item.payment_type}
          size={item.size}
          constructOrderDate={item.constructOrderDate}
        />
      ))
    ) : (
      <div className="d-flex justify-content-center align-items-center">
        {loading ? <SyncOutlined spin /> : "Items Not Available"}
      </div>
    )}
  </div>
  )
}

export default GetPricingData